import { render, staticRenderFns } from "./StatisticsForm.vue?vue&type=template&id=2d303419&scoped=true"
import script from "./StatisticsForm.vue?vue&type=script&lang=js"
export * from "./StatisticsForm.vue?vue&type=script&lang=js"
import style0 from "./StatisticsForm.vue?vue&type=style&index=0&id=2d303419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d303419",
  null
  
)

export default component.exports